<template>
  <div class="left-sidenav-container">
    <md-toolbar class="admin-toolbar" :style="[ContentMargin]" v-if="!IsLoginPage">
      <div class="md-toolbar-container top-fixed-bar">
        <md-layout md-flex="5" md-flex-small="15">
          <md-button
            v-if="!IsLoginPage && hideSideBar == true"
            class="md-icon-button"
            @click="toggleLeftSidenav"
          >
            <md-icon class="md-size-1x" style="color: #002b49">menu</md-icon>
          </md-button>
          <md-button
            v-if="!IsLoginPage && hideSideBar == false"
            class="md-icon-button"
            @click="toggleLeftSidenav1"
          >
            <md-icon class="md-size-1x" style="color: #002b49">menu</md-icon>
          </md-button>
          <!-- <span class="error"> {{formName}}</span> -->
          <!-- <md-button v-if="!IsLoginPage" class="md-icon-button" @click="toggleLeftSidenav">
            <md-icon class="md-size-1x" style="color: #c2c2c2;">refresh</md-icon>
          </md-button>-->
          <!-- <b-form class="d-sm-down-none ml-5" inline>
            <b-form-group>
              <b-input-group class="input-group-no-border">
                <b-form-input :formatter="capitalizeAll" id="search-input" placeholder="Search Dashboard"/>
              </b-input-group>
            </b-form-group>
          </b-form>-->
        </md-layout>
        <md-button class="md-icon-button" @click="toggleSearch()">
          <md-icon class="md-size-1x" style="">search</md-icon>
        </md-button>
        <!-- <md-layout md-flex="15">
          <img src="/assets/logopridelloginpage.png" style="width:148px;height:33px;">
        </md-layout>-->
        <div class="ml-auto row mr-4">
          <div class="col-4 colSetPad" style="margin: auto">
            <b-dropdown offset="-65" variant="link" id="kk" name="jhj" size="lg" no-caret>
              <template slot="button-content">
                <!-- <span style="color: #002b49;font-size: 13px;font-style: oblique">{{UserName}}</span> -->
                <md-icon
                  :style="unseenNotificationList.length > 0 ? 'color: orange' : ''"
                  class="md-size-1x nav-icon"
                  >notifications_none</md-icon
                >

                <b-badge
                  pill
                  v-if="unseenNotificationList.length > 0"
                  style="
                    min-width: 10px !important;
                    max-width: 34px !important;
                    margin-left: -20px;
                    top: -12px !important;
                    font-size: 66% !important;
                  "
                  variant="danger"
                  >{{ unseenNotificationList.length }}</b-badge
                >
                <!-- v-if=" unseenNotificationList.length>0" -->
              </template>

              <b-dropdown-text style="width: 200px">
                {{
                  unseenNotificationList.length > 0
                    ? "task notifications"
                    : "no new notification"
                }}
                <b-badge
                  v-if="unseenNotificationList.length > 0"
                  pill
                  style="cursor: pointer"
                  variant="primary"
                  @click="gotoDo"
                  >view all</b-badge
                >
              </b-dropdown-text>
              <b-dropdown-divider
                v-if="unseenNotificationList.length > 0"
              ></b-dropdown-divider>

              <b-dropdown-item-button
                v-for="(item55, index) in unseenNotificationList"
                :key="index"
              >
                <span class="text-muted" style="text-size: 2px; text-align: left"
                  >Task Title : {{ item55.taskTitle }}</span
                >
              </b-dropdown-item-button>
            </b-dropdown>
          </div>
          <div class="col-8 colSetPad user-name-box">
            <b-dropdown
              id="ksdk"
              name="jhdsdsj"
              offset="-65"
              variant="link"
              size="lg"
              no-caret
            >
              <template slot="button-content">
                <div class="user-admin-name">
                  {{ UserName }}
                  <span class="user-destination-name"> {{ Designation }}</span>
                </div>
                <!-- <span style="color: #002b49;font-size: 13px;font-style: oblique">{{UserName}}</span> -->
                <md-icon class="md-size-1x nav-icon">person_outline</md-icon>
              </template>
              <b-dropdown-item-button v-if="Designation != 'Client'" @click="userProfile">
                <i class="la la-user" />My Profile
              </b-dropdown-item-button>
              <b-dropdown-item-button @click="logout">
                <i class="la la-sign-out" /> Log Out
              </b-dropdown-item-button>
            </b-dropdown>
            <!-- <md-icon style="color: orange;" class="md-size-1x">notifications</md-icon> -->
          </div>
        </div>
      </div>
    </md-toolbar>

    <md-sidenav
      class="onHover"
      v-if="!IsLoginPage"
      ref="leftSidenav"
      @open="open('Left')"
      @close="close('Left')"
    >
      <md-toolbar class="md-small" style="background: #002b49">
        <div class="md-toolbar-container" v-if="hideSideBar == false">
          <img
            src="/assets/logopridelloginpage.png"
            style="width: 148px; height: 33px; margin-left: 45px"
          />
          <!-- <h3 class="md-title top-lt">Pridel</h3> -->
        </div>
        <div v-else>
          <p style="color: white; margin-top: 25px">Pridel</p>
        </div>
      </md-toolbar>

      <div>
        <!-- :class="hideSideBar==false?'opened':'closed'" -->
        <div class="sidenavHalf">
          <md-list>
            <ul
              v-for="(item, index) in Items"
              :key="index"
              style="padding: 0px"
              class="left-nav-button"
            >
              <md-list-item
                @click="(e) => clickRoute(e, item)"
                :style="
                  CurrentPath == item.path
                    ? 'background: linear-gradient(180deg, rgb(0 43 73 / 88%), rgb(21 69 116 / 82%)) !important;margin: 0.5rem 2px; border-radius: 4px;box-shadow: 0 0 10px 1px rgb(0 43 73 / 70%);color:#fff !important;'
                    : style.unselected
                "
                v-if="checkPermission(item.departmentName, item.finalPagePermision)"
              >
                <!-- <b-badge
                  style="min-width: 20px !important;"
                  v-if="item.name=='To Do List' && unseenNotificationList.length>0"
                  variant="warning"
                >{{unseenNotificationList.length}}</b-badge>-->
                <!-- ,item.finalPagePermision -->
                <md-icon
                  class="md-size-1x"
                  v-if="item.meta.icon"
                  :style="
                    CurrentPath == item.path
                      ? 'color: #fff'
                      : unseenNotificationList.length > 0 && item.name == 'To Do List'
                      ? 'color:yellow'
                      : 'color:#625f6e;'
                      ? ''
                      : unseenNotificationList.length > 0 && item.name == 'To Do List'
                      ? 'color:yellow'
                      : 'color:#625f6e;opacity:0.7'
                  "
                  >{{ item.meta.icon }}</md-icon
                >

                <span style="overflow: hidden">{{ item.name }}</span>

                <md-list-expand v-if="item.children">
                  <ul
                    v-for="(subItem, subIndex) in item.children"
                    :key="subIndex"
                    style="padding: 0px"
                  >
                    <md-list
                      v-if="checkPermissionChild(subItem.finalPagePermision)"
                      class="left-nav-button"
                    >
                      <md-list-item
                        v-if="(style = 'width:250px')"
                        class="md-inset"
                        @click="(e) => clickRoute(e, subItem)"
                        :style="
                          CurrentPath == subItem.path
                            ? 'background: linear-gradient(180deg, rgb(0 43 73 / 88%), rgb(21 69 116 / 82%)) !important;box-shadow: 0 0 10px 1px rgb(0 43 73 / 70%);margin: 0.5rem 2px; border-radius: 4px;color:#ffffff !important;'
                            : 'background:#fff !important;'
                        "
                      >
                        <md-icon
                          v-if="subItem.meta.icon"
                          :style="
                            CurrentPath == subItem.path ? 'color:#fff' : style.unselected
                          "
                          >{{ subItem.meta.icon }}</md-icon
                        >
                        <span>{{ subItem.name }}</span>
                      </md-list-item>
                      <!-- {{subItem.name}} -->
                    </md-list>
                    <!-- v-if="checkPermission(subIndex, subItem)" -->
                  </ul>
                </md-list-expand>
              </md-list-item>
            </ul>
          </md-list>
        </div>
      </div>
    </md-sidenav>

    <!-- <md-snackbar :md-position="vertical + ' ' + horizontal" ref="snackbar" :md-duration="duration">
      <span>{{unseenNotificationList.length}} New Notifications</span>
    </md-snackbar>-->
    <!-- /* GLOBAL SEARCH Priyanshu Singh Start */ -->
    <section class="section-global-search" v-if="globalSearch">
      <div class="search-wrapper">
        <div class="search-container">
          <input
            type="search"
            ref="typeBox"
            @keyup.down="nextItem($event)"
            @keyup.up="nextItem($event)"
            @keyup.enter="nextItem($event)"
            @keyup="onSearchComponents()"
            placeholder="Search "
            v-model="searchText"
            autofocus
          />
          <div
            class="py-2 border-top border-muted"
            v-if="searchText && searchText.length > 0"
          >
            <ul class="list-unstyled mb-0 px-2 spot-light-search">
              <li
                v-if="SideNav && SideNav.length > 0"
                v-for="(ChildNav, _index) in SideNav"
                :key="_index"
              >
                <router-link
                  @click.native="toggleSearch()"
                  :to="ChildNav.url"
                  :class="{ 'is-active': _index === arrowCounter }"
                  >{{ ChildNav.name }}
                  <!-- <span class="router-small-font ">
                    - {{ (ChildNav.url) }} -->
                  <!-- </span> -->
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="close-backdrop" @click="toggleSearch()"></div>
      </div>
    </section>
    <!-- /* GLOBAL SEARCH Priyanshu Singh End */ -->
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, APP_NAME } from "../helper/constant.js";
import { APP_IMG } from "../helper/constant.js";
import { sideBarItems } from "../sidebar";
import { mobile_sideBarItems } from "../sidebar/mobile_index";
import { portLogin_sideBarItems } from "../sidebar/port_index";
import { deviceType } from "../helper/enum/deviceType.js";
import { routes } from "../route/allRoutes";

export default {
  beforeMount() {
    // Added By Priyanshu Singh Global Search Start
    if (sessionStorage.getItem("loginStatus") === "true") {
      let userRoles = localStorage.getItem("finalPagePermision");
      userRoles = userRoles.split(",");
      if (userRoles.length > 0) {
        if (this.$sessionsStorage.get("nameUser") == "Bhavneesh") {
          userRoles.push("Billing");
        }
        // console.log(userRoles)

        this.AllSideNav = routes
          .map((v) => {
            // console.log('v.role',v.permissionName);
            // console.log('v.keywords',v.keywords);
            // console.log('v.url',v.path);
            // console.log('v.name',v.name);
            if (v.permissionName && userRoles.includes(v.permissionName)) {
              return {
                name: v.name,
                role: v.permissionName,
                url: v.path,
                keywords: v.keywords,
              };
            }
          })
          .filter((ele) => ele !== undefined);
      }
      // console.log('jdjsljslhdhdj',this.AllSideNav);
      // console.log("new Login");
    } else {
      //localStorage.clear();
      //  window.reload();
    }

    this.fetchTaskNotification();

    // Added By Priyanshu Singh Global Search End

    // if (sessionStorage.getItem("loginStatus") === "true") {
    //   console.log("new Login");
    // } else {
    //   localStorage.clear();
    //   //  window.reload();
    // }

    // this.fetchTaskNotification();

    //      eventBus.$on("formName",e=>{
    // this.formName=e.name
    //     })
  },
  mounted() {
    this.$sessionsStorage.set("tallyVendorId", "");
    this.$sessionsStorage.set("optTypeTransport", "");
    this.$sessionsStorage.set("optAllModuleIdTransport", "");
    this.$nextTick(function () {
      window.setInterval(() => {
        this.fetchTaskNotification();
      }, 90000);
    });
    if (!this.IsLoginPage && this.DeviceType != deviceType.PHONE) {
      this.$nextTick(() => {
        if (this.$refs.leftSidenav && this.$refs.leftSidenav.open) {
          this.$refs.leftSidenav.open();
        }
      });
    }
    this.$events.on(
      "toggleSideBar",
      (eventData) => {
        if (eventData && this.$refs.leftSidenav && this.$refs.leftSidenav.open) {
          this.$refs.leftSidenav.open();
        }
      }
    );
  },
  beforeDestroy() {},
  destroyed() {},
  //   watch: {
  //   shipModal: {
  //     handler: function(newVal, oldVal) {
  //       alert()
  //     },

  //     deep: true
  //   }
  // },
  data() {
    return {
      unseenNotificationList: [],
      vertical: "top",
      horizontal: "center",
      duration: 4000,
      shipModal: "",
      formName: "PS",
      hideSideBar: true,
      style: {
        unselected: { background: "#fff" },
        selected: {
          background: "#1469a3 !important",
          color: "#fff !important",
        },
      },
      routeArray: [
        "/sales/salesBooking",
        "/client/addClient",
        "/client/viewClient",
        "/serviceEstimation/serviceEstimation",
        "/serviceEstimation/viewServiceEstimation",
        "/yard/GateIn",
        "/yard/viewGateIn",
        "/yard/viewMaintain",
        "/yard/gateOut",
        "/yard/viewGateOut",
        "/freightForward/ViewffExportFcl",
        "/freightForward/ffExportFcl",
        "/ffExportCon/ffExportFclConsolidation",
        "/ffExportCon/viewFFConsoExport",
        "/airFreight/viewAirFF",
        "/airFreight/airFFExportConsol",
        "/seaImport/ffseaImportFcl",
        "/seaImport/viewSeaImportDetails",
        "/airImport/ffairImportFcl",
        "/airImport/viewAirImportDetails",
        "/conSeaImport/ffConSeaImportFcl",
        "/conSeaImport/conviewSeaImpDetails",
        "/CCImport/CCImportDetails",
        "/CCImport/CCImportEntry",
        "/CCImport/CCExportDetail",
        "/mainEnquiry/mainEnquiry",
      ],
      AllSideNav: [],
      SideNav: [],
      arrowCounter: 0,
      globalSearch: false,
      searchText: "",
    };
  },
  components: {},
  computed: {
    // userIdNotify() {
    //   return this.$store.getters.userId;
    // },
    IsLoginPage() {
      return this.$store.getters.appCurrentRoute == "/login" ? true : false;
    },
    UserName() {
      return this.$store.getters.userEmail || this.$sessionsStorage.get("nameUser");
    },
    DepartmentList() {
      return this.$store.getters.departmentName.split(",").length > 1
        ? this.$store.getters.departmentName.split(",")
        : this.$sessionsStorage.get("departmentName").split(",");
    },
    DepartmentName() {
      return (
        this.$store.getters.departmentName || this.$sessionsStorage.get("departmentName")
      );
    },
    Designation() {
      return this.$store.getters.designation || this.$sessionsStorage.get("designation");
    },

    NavBarTitle() {
      if (this.$route.path == "/vehicle/invoice") {
        return "Invoice Form ";
      } else if (this.$route.path == "/sales/salesBooking") {
        return "Sales Booking Form ";
      } else if (this.$route.path == "/vehicle/vehicleBooking") {
        return "Vehicle Booking & Follow up Activities Form";
      } else if (this.$route.path == "/vehicle/goodsReceived") {
        return "Generate GRN";
      } else if (this.$route.path == "/dashboard") {
        return "DashBoard";
      } else if (this.$route.path == "/client/addClient") {
        return "Client Form";
      } else if (this.$route.path == "/client/viewClient") {
        return "View Client";
      } else if (this.$route.path == "/listView/viewSalesBooking") {
        return "View SalesBooking";
      } else if (this.$route.path == "/listView/viewInvoice") {
        return "View Invoice";
      } else if (this.$route.path == "/listView/viewQuotation") {
        return "View Quotation";
      } else if (this.$route.path == "/listView/viewAssignmentOrder") {
        return "View Assignment";
      } else if (this.$route.path == "/listView/viewVehicleBooking") {
        return "View Vehicle Booking";
      } else if (this.$route.path == "/vehicle/viewVehicleDetail") {
        return "View Vehicle Details";
      } else if (this.$route.path == "/vehicle/truckMaster") {
        return "Vehicle Form";
      } else if (this.$route.path == "/vehicle/vehicleType") {
        return "Vehicle Type Form";
      } else if (this.$route.path == "/vehicle/vehicleSize") {
        return "Vehicle Size Form";
      } else if (this.$route.path == "/vehicle/viewDriverDetail") {
        return "View Driver Detail";
      } else if (this.$route.path == "/vehicle/driverMaster") {
        return " Driver Form";
      } else if (this.$route.path == "/container/containerSize") {
        return "Container Size Form";
      } else if (this.$route.path == "/container/containerType") {
        return "Container Type Form";
      } else if (this.$route.path == "/location/pickupLocation") {
        return " Location Form";
      } else if (this.$route.path == "/vehicle/hubMaster") {
        return "Hub Form";
      } else if (this.$route.path == "/listView/hireModel") {
        return "Hire Model";
      } else if (this.$route.path == "/userManagement/viewUserDetail") {
        return "View User";
      } else if (this.$route.path == "/userManagement/addUser") {
        return "UserManagement Form";
      } else if (this.$route.path == "/departmentMaster/department") {
        return "Department Form";
      } else if (this.$route.path == "/view/contract") {
        return " Contract Details";
      } else if (this.$route.path == "/viewHireInvoice") {
        return " Hire Invoice Details";
      } else if (this.$route.path == "/MaintDashboard/maintDashboard") {
        return "Maintanence Details";
      } else if (this.$route.path == "/itemMaster/itemMaster") {
        return "Item Master Form";
      } else if (this.$route.path == "/stockIn") {
        return "Stock-In Form";
      } else if (this.$route.path == "/viewStockIn") {
        return "Stock-In Detail";
      } else if (this.$route.path == "/serviceEstimation/serviceEstimation") {
        return "Service Estimation Form";
      } else if (this.$route.path == "/serviceEstimation/viewServiceEstimation") {
        return "Service Estimation Details";
      } else if (this.$route.path == "/jobOrderSheet/viewJobOrder") {
        return "Job Order Details";
      } else if (this.$route.path == "/jobOrderSheet/jobOrderSheet") {
        return "Job Order Form";
      } else if (this.$route.path == "/sales/leads") {
        return "Enquiry Form";
      } else {
        return APP_NAME;
        return APP_IMG;
      }
    },

    SideBarMargin() {
      return { "margin-left": `${this.$store.getters.appSidebarMargin}px` };
    },
    SideBarWidth() {
      return { width: `${this.$store.getters.appSidebarMargin}px` };
    },
    CurrentPath() {
      return this.$route.path;
    },
    ContentMargin() {
      return { "margin-left": `${this.$store.getters.appContentMargin}px` };
    },
    DeviceType() {
      return this.$store.getters.appDeviceType;
    },
    Items() {
      if (this.$sessionsStorage.get("is_Mobile") == "yes") {
        return mobile_sideBarItems;
      } else if (
        this.$sessionsStorage.get("is_Mobile") == "port" &&
        this.$sessionsStorage.get("portLoginAccess") == 1
      ) {
        return portLogin_sideBarItems;
      } else {
        return sideBarItems;
      }
    },
  },
  methods: {
    gotoDo() {
      this.$router.push({
        path: "/toDoList/toDoList",
      });
    },
    fetchTaskNotification() {
      let type_Size = {
        notification: "notification",
        categoryType: "categoryType",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/getDataToDoList.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.unseenNotificationList.length > 0) {
              // this.$refs.snackbar.open();
              this.unseenNotificationList = data.unseenNotificationList;
            } else {
              this.unseenNotificationList = [];
            }
          }
        })
        .catch((error) => {});
    },

    checkPermissionChild(PAGE) {
      let validate = true;
      if (PAGE == "") {
        return true;
      } else {
        let arrayPage1 = [];
        if (this.$store.getters.finalPagePermision != null) {
          if (this.$store.getters.finalPagePermision.split(",").length > 1) {
            arrayPage1 = this.$store.getters.finalPagePermision.split(",");
          } else {
            arrayPage1 = this.$sessionsStorage.get("finalPagePermision").split(",");
          }
        }

        let newValPage1 = arrayPage1.indexOf(PAGE);

        if (newValPage1 >= 0) {
          validate = true;
        } else {
          validate = false;
        }

        if (validate) {
          return true;
        } else {
          return false;
        }
      }
    },
    checkPermission(deptName, PAGE) {
      let array = [];
      let validate = true;

      if (this.$store.getters.departmentName.split(",").length > 1) {
        array = this.$store.getters.departmentName.split(",");
      } else {
        array = this.$sessionsStorage.get("departmentName").split(",");
      }

      let newVal = array.indexOf(deptName);

      if (
        (deptName == "Tracking" || deptName == "Overseas Agent Assignments") &&
        this.$sessionsStorage.get("nameUser") == "Bhavneesh"
      ) {
        newVal = 1;
      }

      if (newVal >= 0) {
        validate = true;
      } else {
        validate = false;
      }

      if (
        PAGE != "" &&
        PAGE != null &&
        ((this.$store.getters.finalPagePermision != "" &&
          this.$store.getters.finalPagePermision != null) ||
          (this.$sessionsStorage.get("finalPagePermision") != "" &&
            this.$sessionsStorage.get("finalPagePermision") != null))
      ) {
        let arrayPage1 = [];
        if (this.$store.getters.finalPagePermision != null) {
          if (this.$store.getters.finalPagePermision.split(",").length > 1) {
            arrayPage1 = this.$store.getters.finalPagePermision.split(",");
          } else {
            arrayPage1 = this.$sessionsStorage.get("finalPagePermision").split(",");
          }
        }

        let newValPage1 = arrayPage1.indexOf(PAGE);

        if (newValPage1 >= 0) {
          validate = true;
        } else {
          validate = false;
        }
      }

      if (validate) {
        // console.log(" True Name => ",deptName)
        return true;
      } else {
        // console.log(" False Name => ",deptName+" Page => ",PAGE)
        return false;
      }
    },

    logout() {
      this.hideSideBar = true;
      //   window.onbeforeunload = function (e) {
      //           var storage = window.localStorage;
      //           storage.clear()
      // }
      this.$sessionsStorage.set("loginId", "");
      this.$sessionsStorage.set("salesBookingId", "");
      this.$sessionsStorage.set("storeGenerateGrn", "");
      this.$sessionsStorage.set("storeQuotationId", "");
      this.$sessionsStorage.set("storeVehicleBookingId", "");
      this.$sessionsStorage.set("storefollowActivityId", "");
      this.$sessionsStorage.set("clientId", "");
      this.$sessionsStorage.set("nameUser", "");
      this.$sessionsStorage.set("editExportFCLId", "");
      this.$sessionsStorage.set("editFFBookingId", "");
      this.$sessionsStorage.set("editFFExecutionId", "");

      this.$sessionsStorage.set("editffFclConsoExportId", "");
      this.$sessionsStorage.set("editconFclBookingId", "");
      this.$sessionsStorage.set("editffConExecutionId", "");
      this.$sessionsStorage.set("editffAirExport", "");
      this.$sessionsStorage.set("editAirExecutionId", "");
      this.$sessionsStorage.set("editAirBookingId", "");
      this.$sessionsStorage.set("editffSeaImportId", "");
      this.$sessionsStorage.set("editffAirImportId", "");
      this.$sessionsStorage.set("editconSeaImportId", "");
      this.$sessionsStorage.set("editCcImportId", "");

      this.$refs.leftSidenav.close();
      // alert(this.$sessionsStorage.get("is_Mobile"))
      if (this.$sessionsStorage.get("is_Mobile") == "yes") {
        localStorage.clear();
        // window.location.href=`${URL_BASE}/mobileLogin`;
        this.$router.push({
          path: "/Login?is_mobile=yes",
        });
      } else if (this.$sessionsStorage.get("is_Mobile") == "port") {
        localStorage.clear();
        // window.location.href=`${URL_BASE}/mobileLogin`;
        this.$router.push({
          path: "/Login?is_mobile=port",
        });
      } else {
        localStorage.clear();
        this.$router.push({
          path: "/Login",
        });
      }
    },
    userProfile() {
      this.$router.push({
        path: "/userManagement/userProfile",
      });
    },

    toggleLeftSidenav() {
      this.hideSideBar = false;
      this.$refs.leftSidenav.toggle();
    },
    toggleLeftSidenav1() {
      this.hideSideBar = true;
      this.$refs.leftSidenav.toggle();
    },

    open(ref) {
      this.$store.dispatch("setSidebarMargin", 250);
    },
    close(ref) {
      this.$store.dispatch("setSidebarMargin", 50);
    },

    clickRoute(e, item) {
      // this.setPermission(item);
      if (item.children == undefined) {
        this.$router.push(item.path);
        if (this.routeArray.filter((x) => x == item.path).length > 0) {
          this.$sessionsStorage.set("salesBookingId", "");
          this.$sessionsStorage.set("storeGenerateGrn", "");
          this.$sessionsStorage.set("storeQuotationId", "");
          this.$sessionsStorage.set("storeVehicleBookingId", "");
          this.$sessionsStorage.set("storefollowActivityId", "");
          this.$sessionsStorage.set("clientId", "");
          this.$sessionsStorage.set("editClientId", "");
          this.$sessionsStorage.set("editVehicleId", "");
          this.$sessionsStorage.set("editDriverId", "");
          this.$sessionsStorage.set("editServiceId", "");
          this.$sessionsStorage.set("editPOId", "");
          this.$sessionsStorage.set("editStockInId", "");
          this.$sessionsStorage.set("editGateInId", "");

          this.$sessionsStorage.set("editExportFCLId", "");
          this.$sessionsStorage.set("editFFBookingId", "");
          this.$sessionsStorage.set("editFFExecutionId", "");

          this.$sessionsStorage.set("editffFclConsoExportId", "");
          this.$sessionsStorage.set("editconFclBookingId", "");
          this.$sessionsStorage.set("editffConExecutionId", "");
          this.$sessionsStorage.set("editffAirExport", "");
          this.$sessionsStorage.set("editAirExecutionId", "");
          this.$sessionsStorage.set("editAirBookingId", "");
          this.$sessionsStorage.set("editffSeaImportId", "");
          this.$sessionsStorage.set("editffAirImportId", "");
          this.$sessionsStorage.set("editconSeaImportId", "");
          this.$sessionsStorage.set("editCcImportId", "");
          this.$sessionsStorage.set("editMainEnqId", "");

          this.$sessionsStorage.set("optTypeTransport", "");
          this.$sessionsStorage.set("optAllModuleIdTransport", "");
        }

        if (this.$store.getters.appDeviceType == deviceType.PHONE) {
          this.$store.dispatch("setSidebarMargin", 50);
          this.$refs.leftSidenav.close();
        }
      }
    },

    // Added By Priyanshu Singh Global Search Section Start
    toggleSearch: function () {
      this.globalSearch = !this.globalSearch;
      // EventBus.$emit("changeInStatusSearch");

      this.$nextTick(() => this.$refs.typeBox && this.$refs.typeBox.focus());
      // this.setHeaderSearch(!this.getHeaderSearch);
      this.searchText = "";
      // this.$refs.search.focus()
    },
    nextItem(event) {
      //   console.log(this.arrowCounter, this.SideNav.length, "this.arrowCounter");
      if (event.keyCode == 38 && this.arrowCounter >= 0) {
        this.arrowCounter--;
      } else if (event.keyCode == 40 && this.arrowCounter < this.SideNav.length - 1) {
        this.arrowCounter++;
      } else if (
        event.keyCode == 13 &&
        this.arrowCounter >= 0 &&
        this.SideNav.length != 0
      ) {
        let path = this.SideNav[this.arrowCounter].url;
        if (path && String(path).length > 0) {
          this.globalSearch = false;
          this.$router.push({
            path: path,
          });
          // .catch(err => {
          //   if (err && err.message) {
          //     this.$toasted.show(err.message);
          //   } else {
          //     this.$toasted.show("Something went wrong.");
          //   }
          // });
        }
      }
      // console.log(this.arrowCounter, this.SideNav.length, "this.arrowCounter");
    },
    onSearchComponents: function () {
      if (this.searchText.length > 0) {
        let searchTextTerms = this.searchText
          .split(" ")
          .filter((x) => x)
          .map((s) => s.toLowerCase());
        // alert(searchTextTerms);
        // console.log("Priyanshu Singh Happy=>",this.searchText,this.AllSideNav)
        let filterByName = this.AllSideNav.filter((x) => {
          if (x.name) {
            for (let term of x.name.toLowerCase().split(" ")) {
              if (searchTextTerms.some((x) => term.includes(x))) return x;
            }
          }
        });
        let filterByKeyWords = this.AllSideNav.filter((x) => {
          if (x.keywords && x.keywords.length > 0) {
            for (let keyword of x.keywords) {
              if (
                keyword
                  .toLowerCase()
                  .split(" ")
                  .some((term) => searchTextTerms.some((x) => term.includes(x)))
              ) {
                return x;
              }
            }
          }
        });
        // console.log(filterByKeyWords)

        this.SideNav = Array.from(new Set([...filterByName, ...filterByKeyWords]));
      } else {
        this.SideNav = this.AllSideNav;
      }
    },
    // Added By Priyanshu Singh Global Search Section End
  },
};
</script>
<style>
.md-dense {
  margin-right: 2%;
}
.md-theme-default a:not(.md-button) {
  color: #2f2752;
}

/* .pagination a:not(.md-button) {
  color: #fff;
  background: #2f2752;
} */

/* .pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  z-index: 3;
  cursor: default;
  text-decoration: none !important;

  
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
} */
/* 
.pagination > .active > a {
  background-color: #f6f6f6 !important;

  border-color: #341ee9;
  color: #000 !important;
  transform: scale(1.1);
  
} */
.pagination > li {
  display: flex !important;
  margin-top: 8px !important;
}

/* .pagination a:not(.md-button):hover {
  color: #fff !important;
  background-color: #36304a !important;
  transform: scale(1.1);
  text-decoration: none !important;
  z-index: 2;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 2px 4px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.14),
    0 1px 14px rgba(0, 0, 0, 0.12);
} */

.md-theme-default.md-button:not([disabled]).md-primary.md-raised:hover {
  /* background-color: #828e94 !important; */
  box-shadow: 2px 4px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.14),
    0 1px 14px rgba(0, 0, 0, 0.12);
  transform: scale(1.02);
}

.table-bordered > tbody > tr > td,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > td,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > thead > tr > th {
  border: 1px solid #c1c1c1;
}

.table-bordered {
  border: 1px solid #c1c1c1;
  /* border: 1px solid #dee2e6; */
  border-radius: 20px !important;
}
.tableSecondry {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.table > thead {
  /* background-color: #e9ecef; */
  background-color: #002b49;
  color: #fff;

  font-weight: unset;
  font-size: 12px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #c1c1c1;
}
.table > tbody > tr:hover {
  box-shadow: inset 0 0 10px grey;
  cursor: pointer;
}
.md-body-1,
body {
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.01em;
  line-height: 20px;
}
.tableMain {
  text-align: left !important;
  border-radius: 0.428rem;
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
  background: white !important;
}
.paginationCss {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

/* .table > thead > tr > th {
  vertical-align: middle !important;
  padding: 15px !important;
} */

td > button {
  border-style: none;
  background: none;
  cursor: pointer;
}
td > button:hover {
  transform: scale(1.1);
}
.back {
  margin-top: 8px;
}
.hr-s {
  margin-top: 10px;
  margin-bottom: 10px;
  border-top: 1px solid #ccc;
}
.hr-gutter {
  border-top: 1px solid #f2f2f2;
}
.heght-1px {
  height: 1px;
}
/* table {
  border-radius: 10px !important;
} */

/* table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  position: absolute;
  bottom: 14px;
  right: 8px;
  display: block;
  font-family: "Glyphicons Halflings";
  opacity: 0.2;
} */
.md-button-color {
  background-color: #002b48 !important;
  /* border-radius: 10px !important; */
}
.md-button-color-toggle {
  background-color: #002b48 !important;
}

.hr-border {
  border-color: #e7dfdf;
  margin-bottom: 5px;

  width: 100%;
}
.log:hover {
  transform: scale(1.08);
}
.HereDialog .md-dialog-content {
  padding: 0px;
}
.HereDialog .md-dialog-content:first-child {
  padding-top: 0px;
}
.modal-close-btnn {
  z-index: 9999;
  color: #fff;
  background-color: #fff;
}

.modal-close-btnn:hover {
  z-index: 9999;
  color: #fff;
  background-color: #fff !important;
  transform: scale(1.08);
}
.modal-header-set {
  background: #0e0052;
  color: #fff;
  padding: 10px;
  z-index: -1;
}
.margn-0px {
  margin: 0px !important;
}
tbody > tr.even {
  background: #fff;
}
.md-theme-default.md-card {
  background-color: #fff;
  margin-top: -2px;

  /* min-height: 500px; */
  /* border: ridge; */
  /* border: double; */
}
.box {
  margin-top: 0% !important;
  display: contents !important;
}

/* .md-sidenav-content::-webkit-scrollbar {
  width: 15px;
} */

::-webkit-scrollbar-track {
  background: whitesmoke;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #cccccc;
}

/* Handle on hover */
/* ::-webkit-scrollbar-thumb:hover {
  background: #0e0052;
} */
.md-button[disabled]:hover {
  cursor: not-allowed !important;
  pointer-events: visible !important;
  transition: scale(1);
}
.md-menu-content {
  max-width: 100% !important;
}
.pointer {
  cursor: pointer;
  color: #0e0052;
}
.pointer:hover {
  box-shadow: inset 0 0 10px grey;
  cursor: pointer;
}
.showMoreData {
  cursor: pointer;
  color: #0e0052;
}
.showMoreData:hover {
  text-decoration: underline;
  cursor: pointer;
}

.md-steps-container {
  display: none;
}
.md-whiteframe {
  background: #fff;
  /* border-radius: 0px;

  border-width: thin; */
  /* box-shadow: none; */
}
.box-shadow-none {
  box-shadow: none !important;
}
.md-chip button {
  position: absolute !important;
}
/* .md-list-item .md-button:not(.md-button-ghost):not(.md-list-item-container) {
  position: absolute;
} */
.text-default {
  color: #000;
}
.vld-overlay .vld-background {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #000;
  opacity: 0.3;

  width: 70;
  height: 100;
}
.ui.dropdown:not(.button) > .default.text[data-v-3a0c7bea],
.ui.default.dropdown:not(.button) > .text[data-v-3a0c7bea] {
  color: rgba(2, 1, 1, 0.87);
}
.labelMargtop {
  margin-top: 10px;
  color: #0000008a;
}
.md-theme-default.md-button:not([disabled]).md-primary.md-raised,
.md-theme-default.md-button:not([disabled]).md-primary.md-fab {
  color: #fff !important;
}
.ui.disabled.dropdown[data-v-3a0c7bea],
.ui.dropdown .menu > .disabled.item[data-v-3a0c7bea] {
  cursor: not-allowed !important;
  background: #002b4912 !important;
  color: black;
  opacity: 1;
}
.md-card .md-card-actions .md-button:last-child {
  margin-right: 21px;
  margin-bottom: 5px;
}
.appMargin300 {
  margin-left: 250px;
  transition: 0.3s;
}
.appMargin0 {
  margin-left: 50px;
  margin-right: 0px;
  transition: 0.3s;
}
/* .appMargin0 {
  margin-left: 100px;
  margin-right: 100px;
  transition: 0s;
} */
.login-div {
  max-width: 480px;
  margin: auto;
  margin-top: 50px;
}

.ql-toolbar {
  display: none;
}
.quill-editor {
  width: 250px !important;
  height: 100px !important;
  background: #fff;
  overflow: -webkit-paged-y;
}
.form-control {
  text-transform: uppercase !important;
  display: block;
  width: 100%;
  height: 28px;
  padding: 18px 5px;
  font-size: 15px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  /* border: 1px solid #aac9d4cc; */
  border: 1px solid #002b4969;
  border-radius: 4px;
}
.mx-input:disabled,
.mx-input.disabled {
  opacity: 1;
  cursor: not-allowed;
  /* background: #ebebe4; */
  background: #002b4926;
}
.mx-input {
  display: inline-block;
  width: 100%;
  height: 34px;
  padding: 18px 5px;
  padding-left: 10px;
  font-size: 15px;
  line-height: 1.4;
  color: #000;
  background-color: #fff;
  /* border: 1px solid #aac9d4cc; */
  border: 1px solid #002b4969;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.md-title {
  margin-top: 7px !important;
}
.ui.selection.dropdown[data-v-3a0c7bea] {
  /* background: #f9f9f9; */
  background: #fff;
  border: 1px solid #002b4969;
}
label {
  padding-top: 10px;
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 400;
  font-size: 14px;
  /* color: green; */
  color: #002b49db;
}
.md-input-container.md-input-focused label,
.md-input-container.md-has-value label {
  pointer-events: auto;
  top: 9px;
  opacity: 1;
  font-size: 13px;
}
.md-input-container .md-icon:not(.md-icon-delete) {
  margin: 15px auto;
}
.md-input-container {
  width: 100%;
  min-height: 44px;
  padding-top: 16px;
  margin: 0px;

  display: -ms-flexbox;
  display: flex;
  position: relative;
}
.error {
  color: red;
  /* margin-top: -12px; */
}
.gutr {
  margin-top: 30px;
}
.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  background-color: #002b4912;
  opacity: 1;
  color: black;
}
textarea.form-control {
  height: auto;
  padding: 5px 8px;
}
body.md-theme-default {
  /* background-color: azure; */
  /* background-color: #fbfbfb; */
  background-color: #f3f3f3;

  color: rgba(0, 0, 0, 0.87);
}
.md-list-item-expand .md-list-expand .md-list {
  padding: 0;
  background: white !important;
}
.menu::-webkit-scrollbar {
  -webkit-appearance: none;
}

.menu::-webkit-scrollbar:vertical {
  width: 11px;
}

.menu::-webkit-scrollbar:horizontal {
  height: 11px;
}

.menu::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid white; /* should match background, can't be transparent */
  background-color: rgba(0, 0, 0, 0.5);
}

.menu::-webkit-scrollbar-track {
  background-color: #fff;
  border-radius: 8px;
}
.box-body {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;

  padding: 0px;
}
.md-card {
  overflow: auto;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  z-index: 1;
  border-radius: 0px;
  box-shadow: none;
}

.md-toolbar {
  transition: none !important;
  transform: none !important;
}
.md-tabs .md-tabs-navigation.md-fixed .md-tabs-navigation-container,
.md-tabs .md-tabs-navigation.md-fixed .md-tabs-navigation-scroll-container {
  -ms-flex: 1;
  flex: 1;
  background: black;
}
.md-theme-default.md-tabs > .md-tabs-navigation .md-tab-indicator {
  background-color: #fff;
  height: 4px;
}
.md-tabs .md-tab {
  padding: 16px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  min-height: 510px;
}
.SearchButton {
  background: sandybrown;
  height: 1%;
  margin-top: 25px;
}
.mainCardBG {
  margin-top: 0px !important;
  /* background: #f6f8fa !important; */
  /* background: #fbfbfb !important; */
  background: #f3f3f3 !important;
  border-top: none !important;
  border-right: none !important;
  border-bottom: none !important;
  border-left: none !important;
  border-radius: 0px !important;
  /* border-left: none !important; */
}
/* .formCard {
  border-radius: 10px;
  box-shadow: 0 4px 6px 0 rgba(0.2, 0.2, 0.2, 0.2);
  transition: 0.5s;
} */
.fade {
  opacity: 1 !important;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #0000006e;
}
.modal-body {
  background: #eaeaea !important;
  border-bottom-left-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}
.modal-header {
  background: #002b49 !important;
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
}
.modal-title {
  color: white !important;
}
.close {
  color: white !important;
}
/* .navbar {
  height: 60px !important;
  padding: none !important;
} */
.md-list-item .md-list-item-container {
  font-size: 13.5px !important;
  font-weight: 400 !important;
  -webkit-box-align: center !important;
  align-items: center !important;
  position: relative !important;
  min-height: 37px !important;
}
.md-sidenav .md-sidenav-content {
  width: 50px;
  pointer-events: all !important;
  transition: 0.3s;
}
.md-sidenav .md-sidenav-content:hover {
  width: 250px !important;
  overflow-y: hidden !important;
}
.md-theme-default.md-sidenav .md-sidenav-content {
  background-color: #ffffff !important;
  box-shadow: 0 0 15px 0 rgb(34 41 47 / 5%);
  -webkit-box-shadow: 0 0 15px 0 rgb(34 41 47 / 5%);
}

.md-sidenav .md-sidenav-content:hover .sidenavHalf {
  overflow-y: auto !important;
  height: 90vh !important;
  background: #ffffff !important;
}
/* .md-list .md-theme-default:hover {
  width: 250px !important;
} */
.md-sidenav.md-active .md-sidenav-content {
  width: 250px !important;
  transition: 0.3s;
}
.md-list-item .md-list-item-container > .md-icon:first-child {
  margin-right: 12px !important ;
}
div.dataTables_wrapper div.dataTables_length label {
  display: none !important;
}
.wrapper {
  width: 100% !important;
}
.mainClick {
  color: #0e0052;
}
a:not(.md-button):not(.md-bottom-bar-item):hover {
  text-decoration: none !important;
}
.navbar {
  height: 0px !important;
  padding: 0px !important;
  border-radius: 0px !important;
  min-height: 40px !important;
  margin-bottom: 5px !important;
  /* background: linear-gradient(90deg, #FFC0CB 50%, #00FFFF 50%); */
  box-shadow: none !important;
  /* background-color: #fbfbfb !important; */
  background-color: #f3f3f3 !important;
}
.navbar-brand {
  margin-left: -11px !important;
  margin-right: 0 !important;
  font-weight: 600;
  line-height: 1.5rem;
  position: relative;
  color: #2f2752;
  height: auto !important;
  /* margin-top: 10px !important; */
}

.navbar-dark .navbar-brand {
  color: #0e0052;
  text-transform: uppercase;
  font-size: 1.3rem !important;
  font-weight: 300px !important;
}
.card-text:last-child {
  margin-bottom: 0;
  /* margin-top: -15px !important; */
}
.formCard {
  /* -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14) !important;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14) !important; */
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  -webkit-box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  border-radius: 0.428rem;
  /* border-radius: 3px !important; */
  background: white !important;
  /* border: none !important; */
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
  /* border-right: none !important;
  border-bottom: none !important;
  border-left: none !important; */
  /* border-radius: 25px !important;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15); */
  /* box-shadow: 0 4px 4px 4px rgba(0.2, 0.2, 0.2, 0.2); */
  /* transition: 0.5s; */
  margin-top: 0px !important;
}
.card {
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  border-radius: 0.428rem !important;
}
.formCardDash {
  /* border-radius: 0px !important; */
  background: white !important;
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  -webkit-box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  border: none;
  border-radius: 0.428rem;
  /* box-shadow: rgba(90, 113, 208, 0.11) 0px 0px 0px 0px,
    rgba(167, 175, 183, 0.33) 0px 4px 16px 0px; */
  /* border: 1px solid rgb(221, 228, 235) !important; */

  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */

  margin-top: 0px !important;
}
/* .modal-header {
  display: none !important;
} */
.navbar-dark .navbar-brand:hover,
.navbar-dark .navbar-brand:focus {
  color: #0e0052 !important;
}
.btn {
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0;
  padding: 0.25rem 0.75rem;
}
.btn-primary {
  color: #fff;
  background-color: #000449ad;
  border-color: #000449ad;
  border: none;
}
.btn-primary:hover {
  color: #fff;
  background-color: #000449ad;
  border-color: #002b49;
  box-shadow: 0 8px 25px -8px #000449ad;
}
/* .btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.25rem !important;
  font-size: 0.82rem !important;
  line-height: 1.4 !important;
  border-radius: 0.2rem !important;
} */
.btn-warning:hover {
  color: #ffffff;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #002b49;
  border-color: #002b49;
}
.btn-outline-dark {
  border-color: #002b49;
  color: #002b49;
}

.btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
  /* border: 1px solid !important; */
}
.md-list {
  padding: 0px 0 !important;
}
.md-list-item {
  background: #ffffff !important;
  /* background-image: linear-gradient(180deg, #002b49, rgb(32, 63, 100)); */
}

.sidenavHalf {
  background: white !important;
}
.navbar.formCard.navbar-dark.bg-primary.navbar-expand-lg {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  /* background: #f6f8fa !important; */
  /* background: #fbfbfb !important; */
  background: #f3f3f3 !important;
}
.opened {
  width: 250px !important;
}
.closed {
  width: 50px !important;
  pointer-events: all;
}
.closed:hover {
  width: 250px !important;
}
.md-list-item-expand {
  min-height: 37px;
  -ms-flex-flow: column wrap;
  flex-flow: column wrap;
  overflow: hidden;
  transform: none !important;
}
/* .md-button:hover:not([disabled]):not(.md-raised) {
  background-color: rgb(34, 11, 165) !important;
} */
/* .tableTitle {
  text-align: center;
} */
.reportrange-text[data-v-267f4ee2] {
  background: #fff;
  cursor: pointer;
  padding: 9px 10px;
  border: 1px solid #ccc;

  height: 38px !important;
}
.md-input-container.md-has-value input,
.md-input-container.md-has-value textarea {
  color: rgb(39 34 34 / 87%);
  margin-top: 20px !important;
}
.md-checkbox .md-checkbox-label {
  height: 20px;
  padding-left: 8px;
  line-height: 20px;
  margin-top: -8px !important;
}
.md-radio .md-radio-label {
  height: 20px;
  padding-left: 8px;
  line-height: 20px;
  margin-top: -8px !important;
}

/* .modal-dialog-doc .modal-dialog {
  max-width: 98%;
  margin: 5;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;

  z-index: 100000;
} */
.md-stepper .md-step-header {
  background: #f3f3f3 !important;
  border: 0;
  cursor: pointer;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  max-height: 72px;
  padding: 24px;
  position: relative;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.md-stepper .md-steps-navigation .md-steps-navigation-container {
  margin-bottom: -15px;
  background: #f3f3f3 !important;
}
.ui.search.dropdown {
  cursor: text;
  position: relative;
  left: 1px;
  z-index: 3;
  text-transform: uppercase !important;
}
.ui.search.dropdown > .text[data-v-3a0c7bea] {
  cursor: text;
  position: relative;
  left: 1px;
  z-index: 3;
  text-transform: uppercase !important;
}
.HeaderMastBanner {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background: green !important;
  color: white !important;
  height: 70px !important;
}
.colSetPad {
  padding-right: 2px !important;
  padding-left: 2px !important;
}
.btn-lg,
.btn-group-lg > .btn {
  padding: 8px !important;
}
.badge-pill {
  padding-right: 4px !important;
  padding-left: 4px !important;
}

.smbutnWidth {
  min-width: 100px;
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border: 1px solid #aac9d4cc;
}
.mx-calendar-header {
  padding: 0 4px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  overflow: hidden;
  width: 282px;
}
.mx-panel-date td,
.mx-panel-date th {
  font-size: 12px;
  width: 41px;
  height: 32px;
  padding: 0;
  overflow: hidden;
  text-align: center;
}
.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
  /* margin-top: 7px; */
  padding-top: 3px;
}
.left-nav-button:hover {
  transform: translateX(8px);
  transition: all 0.4s;
}
/* .table-responsive {
    display: block;
    width: 100%;
    overflow-x: visible;
} */
/* .text-center {
    text-align: left !important;
} */
/* .left-sidenav-container:hover{
  width: 250px !important;
}
.left-sidenav-container:hover .md-toolbar {
  margin-left: 250px !important;
} */
.badge-secondary {
  color: #002b49;
  background-color: #ffffff;
  border: 1px solid #002b49;
}

.breadcrumb-item.active {
  color: #002b49;
  font-weight: 500;
}
.badge-info {
  color: #002b49;
  background-color: #ffffff;
  border: 1px solid #002b49;
}
.badge {
  font-weight: 500;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.caret {
  margin-left: 1rem;
}
.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #000449ad;
  border-color: #000449ad;
}
.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  z-index: 3;
  color: #fff !important;
  cursor: default;
  background-color: #153857;
  border-color: #153857;
}
.md-theme-default.md-checkbox.md-checked .md-checkbox-container {
  background-color: #002b49;
  border-color: #002b49;
  color: #fff;
}
.md-theme-default.md-checkbox.md-primary.md-checked .md-checkbox-container {
  background-color: #002b49;
  border-color: #002b49;
  color: #fff;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  background-color: #002b49;
  border-color: #002b49;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #000449ad;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link:hover {
  color: #ffffff !important;
}
.vue-daterange-picker {
  position: relative;
  display: inline-block;
  min-width: 60px;
  width: 100%;
}
.btn-outline-primary {
  color: #000449ad;
  border-color: #000449ad;
}
.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #000449ad;
  border-color: #000449ad;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #000449ad;
  border-color: #000449ad;
}
.btn-primary.disabled,
.btn-primary:disabled {
  color: #fff;
  background-color: #000449ad;
  border-color: #000449ad;
}
.dropdown-menu.show {
  position: absolute;
  will-change: transform;
  top: 60px !important;
  left: -80px !important;
  transform: none !important;
}
.dropdown-menu {
  position: absolute;
  top: 60px;
  right: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.9rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  box-shadow: 0 5px 25px rgb(34 41 47 / 10%);
  animation: downOut 300ms ease-in-out;
}
.b-dropdown-text {
  font-weight: 400;
}
.md-theme-default.md-toolbar.admin-toolbar {
  transition: all 0.3s ease 0s !important;
}
.user-name-box {
  display: flex;
  align-items: center;
}
.user-admin-name {
  font-size: 1rem;
  font-weight: 500;
  line-height: initial;
  margin-right: 10px;
  color: #6e6b7b;
}
.user-destination-name {
  font-size: 0.8rem;
  text-align: end;
  display: block;
}
.btn-link {
  display: flex;
  text-transform: none;
}
.btn-link:hover {
  text-decoration: none;
}
.btn-link:focus {
  text-decoration: none;
}
.nav-icon {
  color: #6e6b7b !important;
}
.top-fixed-bar {
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  -webkit-box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
}
.md-theme-default.md-list {
  color: #625f6e;
}
.md-icon.md-theme-default.material-icons {
  color: #625f6e;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #33b6c7;
  text-decoration: none;
  background-color: #e9e9e9;
}

.form-control:focus {
  border-color: #002b49;
  box-shadow: none;
}
/* .md-dialog{
  width: 50% !important;
}
.md-dialog-content{
  font-size: 1.5rem !important;
} */
.md-button-red {
  background: red !important;
  color: White !important;
}
.md-button-green {
  background: green !important;
  color: White !important;
}

@keyframes downOut {
  0% {
    -webkit-transform: translateY(1rem);
    transform: translateY(1rem);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 1199px) {
  .formCardDash {
    margin-top: 2rem !important;
  }
}
@media (max-width: 768px) {
  .appMargin0 {
    margin-left: 0px;
  }
  .md-sidenav .md-sidenav-content {
    width: 0px !important;
  }
  .card-body {
    padding: 0.5rem;
  }
  .b-table.table.b-table-stacked-md > tbody > tr > [data-label] {
    display: grid;
    grid-template-columns: 20% auto;
    grid-gap: 0.25rem 1rem;
    white-space: normal;
  }
  .navbar-dark .navbar-brand {
    font-size: 17px !important;
  }
}

/* Added By Priyanshu SIngh Global Search Start */
.search-wrapper .close-backdrop {
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  height: 100%;
  position: absolute;
}
/* Added By Priyanshu SIngh Global Search End */
</style>



// WEBPACK FOOTER //
// sideBar.vue?dc69cefc